import CustomisedButton from '../../../components/button/button';
import CustomisedDropDown from '../../../components/dropDown/dropDown';
import { useEffect, useRef, useState } from 'react';
import { Formik } from 'formik';
import { Button, Grid } from '@mui/material';
import CustomisedCardLine from '../../../components/card/cardLine';
import CustomisedCardUpload from '../../../components/card/cardUpload';
import CustomisedCardLoad from '../../../components/card/cardLoad';
import ResidenceInformationSkeleton from './residenceInformationSkeleton';
import { IResidenceRequest } from '../../../models/residence.model';
import CustomisedErrorCard from '../../../components/card/errorCard';
import {
    IDropDownResponse,
    IGetFormRejectReasonsResponse,
    IRefrenceKeyRequest,
} from '../../../models/registration.model';
import { useMutation, useQueryClient } from 'react-query';
import {
    getDocument,
    getInfo,
    register,
    registerDocument,
    removeDocument,
    update,
} from '../../../services/residential.service';
import {
    IDocumentRequest,
    IDocumentResponse,
    IRegisterDocumentRequest,
} from '../../../models/identity.model';
import {
    IGetInfoResponse,
    IRegisterRequest,
    IUpdateRequest,
} from '../../../models/residential.model';
import { IUploadFile } from '../../../models/uploadFile.model';
import { DOCUMENT_TYPES, REFRENCE_KEY, RESIDENT_DOCUMENT_TYPE } from '../../../config/cacheKey';
import { useDispatch } from 'react-redux';
import { setHeaderTitle } from '../../../redux/headerTitle/headerTitleSlice';
import { getFormRejectReasons } from '../../../services/registration.service';
import CustomisedTextField from '../../../components/textField/textField';
import { IFormInnerState } from '../form/IFormInnerState';
import { GetDocumentTypes } from '../../../services/basicInformation.service';
import { changeRouteType, getNextInnerState, getpervInnerState } from '../../../redux/handleBackBtn/handleBackBtnSlice';
import { useAppBar } from '../../../components/appBar/appBarContext';
import MailBox from '../../../components/icons/MailBox';

export default function ResidenceInformation({ setFormInnerState, setStep, referenceKey }: IFormInnerState) {

    const [selectedCount, setSelectedPart] = useState();
    const [file, setFile] = useState<any>();
    const [data, setData] = useState<IGetInfoResponse>();
    const [fileArray, setFileArray] = useState<IUploadFile[]>([]);
    const [fileInArray, setFileInArray] = useState<File[]>([]);
    const [residentalStateTitle, setResidentalStateTitle] = useState<string>();
    const [residentalStateEnum, setResidentalStateEnum] = useState<string>();
    const [document, setDocument] = useState<IDocumentResponse[]>([]);
    const [delImage, setDelImage] = useState<boolean>(false);
    const [rejectReasons, setRejectReasons] = useState<string[]>([]);
    const [residentialStatus, setResidentialStatus] =
        useState<IDropDownResponse>();
    const [postalCode, setPostalCode] = useState<string>();
    const [address, setAddress] = useState<string>();
    const [getDocumentTypeService, setGetDocumentTypeService] = useState<string[]>([]);
    const [documentType, setDocumentType] = useState<any>();
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const { setHeader } = useAppBar();
    const buttonRef = useRef<any>(null)
    let refrenceKeyRequest = {} as IRefrenceKeyRequest;

    refrenceKeyRequest.referenceKey = referenceKey!;
    const randomKeyForDispatch = Math.random();

    const setChildValue = (childValues: any) => {
        let arrayFile: File[] = [];
        let newArray = fileArray?.filter(
            (item: any) => item.fileUrl !== childValues.fileUrl
        );
        setFileArray(newArray);

        newArray.map((item: any) =>
            arrayFile.push(item.file)
        )
        setFileInArray(arrayFile);

    };
    useEffect(() => {
        GetInfoResidentialMutate(refrenceKeyRequest);
        setGetDocumentTypeService(JSON.parse(localStorage.getItem(DOCUMENT_TYPES)!));
        setHeader('اطلاعات سکونتی', 'residenceInformation');
        queryClient.setQueryData(REFRENCE_KEY, refrenceKeyRequest.referenceKey);
        queryClient.setQueryData(RESIDENT_DOCUMENT_TYPE, 'ResidenceDocument');
        GetRejectReasonsResidenceMutate({
            referenceKey: referenceKey!,
            form: 'Residential'
        })
        dispatch(changeRouteType({ routeType: 'child' }));
        dispatch(getpervInnerState({ prevInnerState: 'forms' + randomKeyForDispatch }));
        setResidentalStateTitle('');
        setFileArray([]);
    }, []);
    useEffect(() => {
        getDocumentTypeService?.map((item: any) =>
            item.documentType === "ResidenceDocument" ? setDocumentType(item) : ''
        )
    }, [getDocumentTypeService])
    useEffect(() => {
        setDelImage(false);
        if (delImage === true) {
            GetInfoResidentialMutate(refrenceKeyRequest);
        }
    }, [delImage]);

    useEffect(() => {
        setResidentalStateTitle(residentialStatus?.title);
        setResidentalStateEnum(residentialStatus?.enumName);
        if (residentialStatus !== undefined && residentialStatus !== null) {
            GetRejectReasonsResidenceMutate({
                referenceKey: referenceKey!,
                form: 'Residential'
            })
        }
    }, [residentialStatus]);

    useEffect(() => {
        if (file !== undefined && documentType?.fileExtensions.includes(file.file.type)) {
            setFileArray([...fileArray, file]);
            setFileInArray([...fileInArray, file.file!]);
        }
        if (file !== undefined && data?.residentialStatus != null) {
            const registerDocument = {} as IRegisterDocumentRequest;
            const reader = new FileReader();
            if (file?.file) {

                reader.readAsDataURL(file?.file!)
            }
            reader.onloadend = () => {
                registerDocument.base64Date = reader.result!;
            };
            registerDocument.base64Date = file?.fileUrl ? file?.fileUrl : '';
            registerDocument.documentType = 'ResidenceDocument';
            registerDocument.referenceKey = referenceKey!;
            registerDocument.data = file?.file!;
            RegisterDocumentResidentialMutate(registerDocument);
        }
    }, [file]);

    const { mutate: GetRejectReasonsResidenceMutate } = useMutation(
        getFormRejectReasons,
        {
            onSuccess: (data: IGetFormRejectReasonsResponse[]) => {
                setRejectReasons(data[0]?.rejectReasons)
            },
        }
    );
    const currentSelection = (e: any) => {
        setSelectedPart(
            e.target.value.substring(
                e.target.selectionStart,
                e.target.selectionEnd
            ).length
        );
    };

    var value = {} as IDropDownResponse;
    value.id = 1;
    value.title = 'مالک هستم';
    value.enumName = 'Owner';
    var value2 = {} as IDropDownResponse;
    value2.id = 2;
    value2.title = 'مستاجر هستم';
    value2.enumName = 'Tenant';
    var options = [value, value2];

    const { mutate: GetInfoResidentialMutate, isLoading } = useMutation(getInfo, {
        onSuccess: (data: IGetInfoResponse) => {
            if (data) {
                setResidentalStateTitle(data.residentalStateTitle);
                setDocument(data.documents);
                setResidentalStateEnum(data.residentialStatus);
                setData(data);
                setPostalCode(data.postalCode);
                setAddress(data.address);
                setFileArray([]);
                setFileInArray([]);
            }
        },
        onError: () => { },
    });

    const { mutate: RegisterResidentialMutate } = useMutation(register, {
        onSuccess: (data: boolean) => {
            if (data) {
                dispatch(getNextInnerState({ nextInnerState: `formLists ${randomKeyForDispatch} ` }));
            }
        },
    });
    const { mutate: UpdateResidentialMutate } = useMutation(update, {
        onSuccess: (data: boolean) => {
            if (data) {
                dispatch(getNextInnerState({ nextInnerState: `formLists ${randomKeyForDispatch} ` }));
            }
        },
    });
    const { mutate: RegisterDocumentResidentialMutate } = useMutation(
        registerDocument,
        {
            onSuccess: (data: IDocumentResponse) => {
                if (data) {
                    setDocument([...document, data]);
                    GetRejectReasonsResidenceMutate({
                        referenceKey: referenceKey!,
                        form: 'Residential'
                    })
                }
            },
        }
    );
    const arrayList = [
        {
            title: <><MailBox sx={{ marginLeft: "5px", fontSize: "20px", marginBottom: "5px" }} /> کد پستی محل سکونت</>
            ,
            value: postalCode
        },
        {
            title: address
        }
    ]

    const handleContinue = () => {
        // dispatch(getNextInnerState({ nextInnerState: `formLists ${randomKeyForDispatch} ` }));
    }
    if (isLoading) {
        return <ResidenceInformationSkeleton />
    } else {
        return (
            <div className="container-height-drawer">
                <div className='content-container'>
                    <div className='drawer-content'>
                        <Formik
                            initialValues={{} as IRegisterRequest}
                            onSubmit={(values: IRegisterRequest) => {
                                values.residentialStatus = residentalStateEnum!;
                                values.referenceKey =
                                    refrenceKeyRequest.referenceKey;
                                values.files = fileInArray;
                                const updateRequest = {} as IUpdateRequest;
                                updateRequest.referenceKey =
                                    refrenceKeyRequest.referenceKey;
                                updateRequest.residentialStatus =
                                    residentialStatus?.enumName! ? residentialStatus?.enumName! : residentalStateEnum!;
                                data?.residentalStateTitle === '' ||
                                    data?.residentalStateTitle === null
                                    ? RegisterResidentialMutate(values)
                                    : UpdateResidentialMutate(updateRequest);
                            }}
                        >
                            {({
                                handleSubmit,
                                handleChange,
                                values,
                                errors,
                                touched,
                                handleBlur,
                            }) => (
                                <form
                                    onSubmit={handleSubmit}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            handleSubmit();
                                        }
                                    }}
                                >
                                    <div className="centerClass">
                                        <Grid
                                            container
                                            className="row"
                                            spacing={2}
                                            style={{
                                                alignItems: 'center',
                                                width: '98%',
                                                margin: 'auto',
                                            }}
                                        >
                                            {rejectReasons?.length > 0 ? <Grid
                                                container
                                                className="row"
                                                spacing={2}
                                                style={{
                                                    alignItems: 'center',
                                                    width: '98%',
                                                    margin: 'auto',
                                                }}
                                            >
                                                <CustomisedErrorCard titleList={rejectReasons} />
                                            </Grid> : ""

                                            }
                                            <Grid item xs={12} style={{ marginBottom: '10px' }}>
                                                <span className='anjomanRegular'>اطلاعات محل سکونت</span>
                                            </Grid>
                                            <Grid
                                                container
                                                className="row"
                                                spacing={2}
                                                style={{
                                                    alignItems: 'center',
                                                    width: '98%',
                                                    margin: 'auto',
                                                }}
                                            >
                                                <CustomisedCardLine
                                                    itemList={arrayList}
                                                />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    padding: '0px',
                                                    marginTop: '2rem',
                                                }}
                                            >
                                                <CustomisedDropDown
                                                    title={
                                                        residentalStateTitle
                                                            ? residentalStateTitle
                                                            : residentialStatus
                                                                ? residentialStatus.title
                                                                : 'وضعیت سکونت'
                                                    }
                                                    options={options}
                                                    label="وضعیت سکونت"
                                                    setSelectedItem={setResidentialStatus}
                                                    isSelected={residentalStateTitle ? true : false}
                                                ></CustomisedDropDown>
                                            </Grid>

                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    padding: '0px',
                                                    marginTop: '1.5rem',
                                                }}
                                            >
                                                {
                                                    document != undefined &&
                                                        document != null &&
                                                        document.length > 0 ? (
                                                        <>
                                                            {document?.map((item) => (
                                                                <CustomisedCardLoad
                                                                    comment={documentType?.hints?.length > 100 ?
                                                                        documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                    title={
                                                                        item?.documentTypeTitle
                                                                    }
                                                                    fileSelected={
                                                                        item?.fileUrl
                                                                    }
                                                                    documentId={
                                                                        item?.fileId
                                                                    }
                                                                    setDelImage={
                                                                        setDelImage
                                                                    }
                                                                    setChildValue={
                                                                        setChildValue
                                                                    }
                                                                    fileArray={fileArray}
                                                                    serviceName={
                                                                        removeDocument
                                                                    }
                                                                    serviceRequestObj={
                                                                        {
                                                                            referenceKey:
                                                                                refrenceKeyRequest.referenceKey,
                                                                            documentId:
                                                                                item?.fileId,
                                                                        } as IDocumentRequest
                                                                    }
                                                                    fileType={item.fileType}
                                                                />
                                                            ))}
                                                            <CustomisedCardUpload
                                                                title={documentType?.title}
                                                                comment={documentType?.hints?.length > 100 ?
                                                                    documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                setFileSelected={setFile}
                                                                fileExtensions={documentType?.fileExtensions}
                                                                maxSizeKb={documentType?.maxSizeKb}
                                                                fileType={documentType?.fileType}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            {fileArray?.map((fileArray) => (
                                                                <CustomisedCardLoad
                                                                    comment={documentType?.hints?.length > 100 ?
                                                                        documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                    title={documentType?.title}
                                                                    fileSelected={
                                                                        fileArray.fileUrl
                                                                    }
                                                                    setChildValue={
                                                                        setChildValue
                                                                    }
                                                                    fileArray={fileArray}
                                                                    fileType={fileArray?.file?.type}
                                                                />
                                                            ))}
                                                            {documentType !== null && documentType !== undefined ?
                                                                <CustomisedCardUpload
                                                                    title={documentType?.title}
                                                                    comment={documentType?.hints?.length > 100 ?
                                                                        documentType?.hints.slice(0, 100) + '...' : documentType?.hints}
                                                                    setFileSelected={setFile}
                                                                    setChildValue={
                                                                        setChildValue
                                                                    }
                                                                    fileExtensions={documentType?.fileExtensions}
                                                                    maxSizeKb={documentType?.maxSizeKb}
                                                                    fileType={documentType?.fileType}
                                                                /> : null
                                                            }
                                                        </>
                                                    )
                                                }
                                            </Grid>
                                            <div className="pt-5 button-container">
                                                <Button
                                                    onClick={handleContinue}
                                                    type="submit"
                                                    ref={buttonRef}
                                                    style={{ display: "none" }}
                                                ></Button>
                                            </div>
                                        </Grid>
                                    </div>
                                </form>
                            )}
                        </Formik>
                    </div>
                    <div className="py-5">
                        <CustomisedButton
                            onClick={() => {
                                if (buttonRef.current) {
                                    buttonRef.current.click()
                                }

                            }}
                            title='ادامه'
                            type='button'
                            disable={
                                (residentalStateTitle === null ||
                                    residentalStateTitle === undefined || residentalStateTitle === "" ||
                                    (fileArray.length === 0 && document.length === 0)
                                )
                                    ? true
                                    : false
                            }

                        />

                    </div>
                </div>
            </div>

        );
    }
}
